import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config';
import './Dashboard.css';
import './DataPage.css';
import Pagination from '../components/Pagination';

function Medicos() {
  const navigate = useNavigate();
  const [medicos, setMedicos] = useState([]);
  const [allMedicos, setAllMedicos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalAberto, setModalAberto] = useState(false);
  const [medicoSelecionado, setMedicoSelecionado] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(0);

  // Filtros
  const [filtros, setFiltros] = useState({
    search: '',
    especialidade: '',
    conselho: '',
    uf: '',
    ativo: 'true'
  });

  // Função para obter últimos 30 dias
  const getDefaultDates = () => {
    const hoje = new Date();
    const dataFim = hoje.toISOString().split('T')[0];
    const dataInicio = new Date(hoje.setDate(hoje.getDate() - 30)).toISOString().split('T')[0];
    return { dataInicio, dataFim };
  };

  // Filtros de data e ordenação
  const [dataInicio, setDataInicio] = useState(getDefaultDates().dataInicio);
  const [dataFim, setDataFim] = useState(getDefaultDates().dataFim);
  const [sortBy, setSortBy] = useState('TOTAL_SOLICITACOES');
  const [sortOrder, setSortOrder] = useState('DESC');

  // Form data
  const [formData, setFormData] = useState({
    CRM: '',
    NOME: '',
    CPF: '',
    ENDERECO: '',
    BAIRRO: '',
    CEP: '',
    CIDADE: '',
    ESTADO: '',
    TELEFONECLINICA: '',
    TELEFONEHOSPITAL: '',
    TELEFONERESIDENCIA: '',
    TELEFONECELULAR: '',
    FAX: '',
    EMAIL: '',
    ESPECIALIDADE: '',
    CONSELHO_PROFISSIONAL: 'CRM',
    UF_CONSELHO: '',
    DATA_NASCIMENTO: '',
    INATIVO: 'F'
  });

  useEffect(() => {
    fetchMedicos();
  }, [filtros, currentPage, dataInicio, dataFim, sortBy, sortOrder]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filtros.search, filtros.especialidade, filtros.conselho, filtros.uf, filtros.ativo, dataInicio, dataFim]);

  const fetchMedicos = async () => {
    try {
      const token = localStorage.getItem('token');
      const params = new URLSearchParams();

      if (filtros.search) params.append('search', filtros.search);
      if (filtros.especialidade) params.append('especialidade', filtros.especialidade);
      if (filtros.conselho) params.append('conselho', filtros.conselho);
      if (filtros.uf) params.append('uf', filtros.uf);
      if (filtros.ativo) params.append('ativo', filtros.ativo);
      if (dataInicio) params.append('dataInicio', dataInicio);
      if (dataFim) params.append('dataFim', dataFim);
      if (sortBy) params.append('sortBy', sortBy);
      if (sortOrder) params.append('sortOrder', sortOrder);

      const response = await axios.get(`${API_URL}/medicos?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const data = response.data;
      setAllMedicos(data);
      setTotalItems(data.length);

      // Aplicar paginação
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const paginatedData = data.slice(startIndex, endIndex);
      setMedicos(paginatedData);
    } catch (error) {
      console.error('Erro ao buscar médicos:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFiltroChange = (campo, valor) => {
    setFiltros(prev => ({ ...prev, [campo]: valor }));
  };

  const limparFiltros = () => {
    setFiltros({
      search: '',
      especialidade: '',
      conselho: '',
      uf: '',
      ativo: 'true'
    });
    const defaults = getDefaultDates();
    setDataInicio(defaults.dataInicio);
    setDataFim(defaults.dataFim);
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === 'ASC' ? 'DESC' : 'ASC');
    } else {
      setSortBy(field);
      setSortOrder('DESC');
    }
  };

  const abrirModalNovo = () => {
    setMedicoSelecionado(null);
    setFormData({
      CRM: '',
      NOME: '',
      CPF: '',
      ENDERECO: '',
      BAIRRO: '',
      CEP: '',
      CIDADE: '',
      ESTADO: '',
      TELEFONECLINICA: '',
      TELEFONEHOSPITAL: '',
      TELEFONERESIDENCIA: '',
      TELEFONECELULAR: '',
      FAX: '',
      EMAIL: '',
      ESPECIALIDADE: '',
      CONSELHO_PROFISSIONAL: 'CRM',
      UF_CONSELHO: '',
      DATA_NASCIMENTO: '',
      INATIVO: 'F'
    });
    setModalAberto(true);
  };

  const abrirModalEditar = async (medico) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/medicos/${medico.ID}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const data = response.data;
      setMedicoSelecionado(data);
      setFormData({
        CRM: data.CRM || '',
        NOME: data.NOME || '',
        CPF: data.CPF || '',
        ENDERECO: data.ENDERECO || '',
        BAIRRO: data.BAIRRO || '',
        CEP: data.CEP || '',
        CIDADE: data.CIDADE || '',
        ESTADO: data.ESTADO || '',
        TELEFONECLINICA: data.TELEFONECLINICA || '',
        TELEFONEHOSPITAL: data.TELEFONEHOSPITAL || '',
        TELEFONERESIDENCIA: data.TELEFONERESIDENCIA || '',
        TELEFONECELULAR: data.TELEFONECELULAR || '',
        FAX: data.FAX || '',
        EMAIL: data.EMAIL || '',
        ESPECIALIDADE: data.ESPECIALIDADE || '',
        CONSELHO_PROFISSIONAL: data.CONSELHO_PROFISSIONAL || 'CRM',
        UF_CONSELHO: data.UF_CONSELHO || '',
        DATA_NASCIMENTO: data.DATA_NASCIMENTO ? new Date(data.DATA_NASCIMENTO).toISOString().split('T')[0] : '',
        INATIVO: data.INATIVO || 'F'
      });
      setModalAberto(true);
    } catch (error) {
      console.error('Erro ao buscar médico:', error);
      alert('Erro ao carregar dados do médico');
    }
  };

  const fecharModal = () => {
    setModalAberto(false);
    setMedicoSelecionado(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem('token');

      if (medicoSelecionado) {
        // Editar
        await axios.put(`${API_URL}/medicos/${medicoSelecionado.ID}`, formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
        alert('Médico atualizado com sucesso!');
      } else {
        // Criar
        await axios.post(`${API_URL}/medicos`, formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
        alert('Médico cadastrado com sucesso!');
      }

      fecharModal();
      fetchMedicos();
    } catch (error) {
      console.error('Erro ao salvar médico:', error);
      alert('Erro ao salvar médico: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleInativar = async (id) => {
    if (!window.confirm('Deseja realmente inativar este médico?')) return;

    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/medicos/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('Médico inativado com sucesso!');
      fetchMedicos();
    } catch (error) {
      console.error('Erro ao inativar médico:', error);
      alert('Erro ao inativar médico');
    }
  };

  const formatTelefone = (tel) => {
    if (!tel) return '-';
    return tel;
  };

  const formatCPF = (cpf) => {
    if (!cpf) return '-';
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  };

  const styles = {
    pageHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '24px',
      flexWrap: 'wrap',
      gap: '12px',
    },
    pageIcon: {
      fontSize: '1.5rem',
      lineHeight: 1,
    },
    pageTitle: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#1a1a2e',
      margin: '0 0 2px 0',
    },
    pageSubtitle: {
      fontSize: '0.85rem',
      color: '#666',
      margin: 0,
    },
    btnPrimary: {
      padding: '10px 20px',
      backgroundColor: '#1976d2',
      color: '#fff',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '0.9rem',
      fontWeight: '600',
      whiteSpace: 'nowrap',
    },
  };

  if (loading) {
    return <div className="dashboard-page data-page">Carregando...</div>;
  }

  return (
    <div className="dashboard-page data-page">
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>👨‍⚕️</span>
          <div>
            <h1 style={styles.pageTitle}>Médicos Solicitantes</h1>
            <p style={styles.pageSubtitle}>Cadastro de médicos do laboratório</p>
          </div>
        </div>
        <button style={styles.btnPrimary} onClick={abrirModalNovo}>+ Novo Médico</button>
      </div>

      {/* Cards de Estatísticas */}
      <div className="responsive-grid" style={{ marginBottom: '20px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '20px',
          borderRadius: '10px',
          color: 'white',
          textAlign: 'center'
        }}>
          <h3 style={{ margin: '0 0 5px 0', fontSize: '2rem' }}>{allMedicos.length}</h3>
          <p style={{ margin: 0, opacity: 0.9 }}>Total de Médicos</p>
        </div>

        <div style={{
          background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
          padding: '20px',
          borderRadius: '10px',
          color: 'white',
          textAlign: 'center'
        }}>
          <h3 style={{ margin: '0 0 5px 0', fontSize: '2rem' }}>
            {allMedicos.reduce((sum, m) => sum + (m.TOTAL_SOLICITACOES || 0), 0)}
          </h3>
          <p style={{ margin: 0, opacity: 0.9 }}>Total de Solicitações</p>
        </div>

        <div style={{
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          padding: '20px',
          borderRadius: '10px',
          color: 'white',
          textAlign: 'center'
        }}>
          <h3 style={{ margin: '0 0 5px 0', fontSize: '2rem' }}>
            {allMedicos.filter(m => m.TOTAL_SOLICITACOES > 0).length}
          </h3>
          <p style={{ margin: 0, opacity: 0.9 }}>Médicos com Solicitações</p>
        </div>

        <div style={{
          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
          padding: '20px',
          borderRadius: '10px',
          color: 'white',
          textAlign: 'center'
        }}>
          <h3 style={{ margin: '0 0 5px 0', fontSize: '2rem' }}>
            {allMedicos.length > 0 ? Math.round(allMedicos.reduce((sum, m) => sum + (m.TOTAL_SOLICITACOES || 0), 0) / allMedicos.filter(m => m.TOTAL_SOLICITACOES > 0).length || 0) : 0}
          </h3>
          <p style={{ margin: 0, opacity: 0.9 }}>Média por Médico</p>
        </div>
      </div>

      {/* Filtros */}
      <div className="filters-section" style={{
        background: 'white',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', fontSize: '0.9rem' }}>
              Buscar
            </label>
            <input
              type="text"
              placeholder="Nome, CRM ou CPF..."
              value={filtros.search}
              onChange={(e) => handleFiltroChange('search', e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '0.95rem'
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', fontSize: '0.9rem' }}>
              Especialidade
            </label>
            <input
              type="text"
              placeholder="Especialidade..."
              value={filtros.especialidade}
              onChange={(e) => handleFiltroChange('especialidade', e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '0.95rem'
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', fontSize: '0.9rem' }}>
              Conselho
            </label>
            <select
              value={filtros.conselho}
              onChange={(e) => handleFiltroChange('conselho', e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '0.95rem'
              }}
            >
              <option value="">Todos</option>
              <option value="CRM">CRM</option>
              <option value="CRO">CRO</option>
              <option value="CRN">CRN</option>
              <option value="CREFITO">CREFITO</option>
            </select>
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', fontSize: '0.9rem' }}>
              UF
            </label>
            <input
              type="text"
              placeholder="UF..."
              value={filtros.uf}
              onChange={(e) => handleFiltroChange('uf', e.target.value.toUpperCase())}
              maxLength={2}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '0.95rem'
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', fontSize: '0.9rem' }}>
              Status
            </label>
            <select
              value={filtros.ativo}
              onChange={(e) => handleFiltroChange('ativo', e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '0.95rem'
              }}
            >
              <option value="">Todos</option>
              <option value="true">Ativos</option>
              <option value="false">Inativos</option>
            </select>
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', fontSize: '0.9rem' }}>
              Data Início
            </label>
            <input
              type="date"
              value={dataInicio}
              onChange={(e) => setDataInicio(e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '0.95rem'
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', fontSize: '0.9rem' }}>
              Data Fim
            </label>
            <input
              type="date"
              value={dataFim}
              onChange={(e) => setDataFim(e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '0.95rem'
              }}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            <button
              onClick={limparFiltros}
              style={{
                padding: '8px 16px',
                background: '#6b7280',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '0.9rem',
                fontWeight: '500'
              }}
            >
              🗑️ Limpar Filtros
            </button>
          </div>
        </div>
      </div>

      {/* Tabela */}
      <div style={{ background: 'white', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', overflow: 'hidden', overflowX: 'auto' }}>
        <table className="data-table compact-table" style={{ width: '100%' }}>
          <thead>
            <tr>
              <th style={{ width: '80px' }}>ID</th>
              <th onClick={() => handleSort('NOME')} className="sortable" style={{ cursor: 'pointer' }}>
                Médico {sortBy === 'NOME' && (sortOrder === 'ASC' ? '↑' : '↓')}
              </th>
              <th style={{ width: '200px' }}>Contato</th>
              <th
                onClick={() => handleSort('TOTAL_SOLICITACOES')}
                className="sortable"
                style={{ width: '140px', textAlign: 'center', cursor: 'pointer' }}
              >
                Solicitações {sortBy === 'TOTAL_SOLICITACOES' && (sortOrder === 'ASC' ? '↑' : '↓')}
              </th>
              <th style={{ width: '100px' }}>Status</th>
              <th style={{ width: '180px' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {medicos.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                  Nenhum médico encontrado
                </td>
              </tr>
            ) : (
              medicos.map(medico => (
                <React.Fragment key={medico.ID}>
                  <tr
                    onClick={() => navigate(`/solicitacoes?medicoId=${medico.ID}`)}
                    style={{ cursor: 'pointer' }}
                    className="clickable-row"
                  >
                    <td rowSpan="2" style={{ verticalAlign: 'top', paddingTop: '16px' }}>
                      <strong>{medico.ID}</strong>
                    </td>
                    <td>
                      <strong style={{ fontSize: '1.05rem', color: '#1f2937' }}>{medico.NOME}</strong>
                      <div style={{ marginTop: '4px', color: '#6b7280', fontSize: '0.9rem' }}>
                        {medico.CONSELHO_PROFISSIONAL || 'CRM'} {medico.CRM} / {medico.UF_CONSELHO || '-'}
                        {medico.ESPECIALIDADE && ` • ${medico.ESPECIALIDADE}`}
                      </div>
                    </td>
                    <td rowSpan="2" style={{ verticalAlign: 'top', paddingTop: '16px', fontSize: '0.9rem' }}>
                      {medico.TELEFONECELULAR && <div>📱 {medico.TELEFONECELULAR}</div>}
                      {medico.TELEFONECLINICA && <div>☎️ {medico.TELEFONECLINICA}</div>}
                      {medico.EMAIL && <div style={{ fontSize: '0.85rem', color: '#6b7280', marginTop: '4px' }}>📧 {medico.EMAIL}</div>}
                      {!medico.TELEFONECELULAR && !medico.TELEFONECLINICA && !medico.EMAIL && '-'}
                    </td>
                    <td rowSpan="2" style={{ verticalAlign: 'top', paddingTop: '16px', textAlign: 'center' }}>
                      <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#3b82f6' }}>
                        {medico.TOTAL_SOLICITACOES || 0}
                      </div>
                      {medico.ULTIMA_SOLICITACAO && (
                        <div style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '4px' }}>
                          Última: {new Date(medico.ULTIMA_SOLICITACAO).toLocaleDateString('pt-BR')}
                        </div>
                      )}
                    </td>
                    <td rowSpan="2" style={{ verticalAlign: 'top', paddingTop: '16px' }}>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '0.75rem',
                        fontWeight: '600',
                        background: medico.INATIVO === 'F' ? '#d1fae5' : '#fee2e2',
                        color: medico.INATIVO === 'F' ? '#065f46' : '#991b1b',
                        display: 'inline-block',
                        width: '100%',
                        textAlign: 'center'
                      }}>
                        {medico.INATIVO === 'F' ? 'Ativo' : 'Inativo'}
                      </span>
                    </td>
                    <td rowSpan="2" style={{ verticalAlign: 'top', paddingTop: '16px' }} onClick={(e) => e.stopPropagation()}>
                      <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
                        <button
                          onClick={() => abrirModalEditar(medico)}
                          style={{
                            padding: '6px 10px',
                            background: '#3b82f6',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '0.85rem',
                            fontWeight: '500'
                          }}
                        >
                          ✏️ Editar
                        </button>
                        {medico.INATIVO === 'F' && (
                          <button
                            onClick={() => handleInativar(medico.ID)}
                            style={{
                              padding: '6px 10px',
                              background: '#ef4444',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '0.85rem',
                              fontWeight: '500'
                            }}
                          >
                            ❌ Inativar
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr
                    onClick={() => navigate(`/solicitacoes?medicoId=${medico.ID}`)}
                    style={{ cursor: 'pointer' }}
                    className="clickable-row"
                  >
                    <td style={{ borderTop: 'none', paddingTop: '0', color: '#6b7280', fontSize: '0.9rem' }}>
                      CPF: {formatCPF(medico.CPF)}
                      {medico.CIDADE && medico.ESTADO && ` • ${medico.CIDADE}/${medico.ESTADO}`}
                    </td>
                  </tr>
                </React.Fragment>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Paginação */}
      <Pagination
        currentPage={currentPage}
        totalPages={Math.ceil(totalItems / itemsPerPage)}
        onPageChange={setCurrentPage}
        itemsPerPage={itemsPerPage}
        totalItems={totalItems}
      />

      {/* Modal */}
      {modalAberto && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}
          onClick={fecharModal}
        >
          <div
            style={{
              background: 'white',
              borderRadius: '12px',
              maxWidth: '800px',
              width: '90%',
              maxHeight: '90vh',
              overflow: 'auto',
              padding: '0'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{
              padding: '20px',
              borderBottom: '1px solid #e5e7eb',
              position: 'sticky',
              top: 0,
              background: 'white',
              zIndex: 10
            }}>
              <h2 style={{ margin: 0, fontSize: '1.5rem' }}>
                {medicoSelecionado ? '✏️ Editar Médico' : '➕ Novo Médico'}
              </h2>
            </div>

            <form onSubmit={handleSubmit} style={{ padding: '20px' }}>
              <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px' }}>
                {/* Nome */}
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    Nome Completo *
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.NOME}
                    onChange={(e) => setFormData({...formData, NOME: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                {/* Conselho */}
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    Conselho Profissional *
                  </label>
                  <select
                    required
                    value={formData.CONSELHO_PROFISSIONAL}
                    onChange={(e) => setFormData({...formData, CONSELHO_PROFISSIONAL: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  >
                    <option value="CRM">CRM</option>
                    <option value="CRO">CRO</option>
                    <option value="CRN">CRN</option>
                    <option value="CREFITO">CREFITO</option>
                    <option value="COREN">COREN</option>
                  </select>
                </div>

                {/* CRM */}
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    Número de Registro *
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.CRM}
                    onChange={(e) => setFormData({...formData, CRM: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                {/* UF */}
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    UF do Conselho
                  </label>
                  <input
                    type="text"
                    maxLength={2}
                    value={formData.UF_CONSELHO}
                    onChange={(e) => setFormData({...formData, UF_CONSELHO: e.target.value.toUpperCase()})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                {/* Especialidade */}
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    Especialidade
                  </label>
                  <input
                    type="text"
                    value={formData.ESPECIALIDADE}
                    onChange={(e) => setFormData({...formData, ESPECIALIDADE: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                {/* CPF */}
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    CPF
                  </label>
                  <input
                    type="text"
                    value={formData.CPF}
                    onChange={(e) => setFormData({...formData, CPF: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                {/* Data Nascimento */}
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    Data de Nascimento
                  </label>
                  <input
                    type="date"
                    value={formData.DATA_NASCIMENTO}
                    onChange={(e) => setFormData({...formData, DATA_NASCIMENTO: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                {/* Email */}
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    E-mail
                  </label>
                  <input
                    type="email"
                    value={formData.EMAIL}
                    onChange={(e) => setFormData({...formData, EMAIL: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                {/* Telefones */}
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    Telefone Celular
                  </label>
                  <input
                    type="text"
                    value={formData.TELEFONECELULAR}
                    onChange={(e) => setFormData({...formData, TELEFONECELULAR: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    Telefone Clínica
                  </label>
                  <input
                    type="text"
                    value={formData.TELEFONECLINICA}
                    onChange={(e) => setFormData({...formData, TELEFONECLINICA: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                {/* Endereço */}
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    Endereço
                  </label>
                  <input
                    type="text"
                    value={formData.ENDERECO}
                    onChange={(e) => setFormData({...formData, ENDERECO: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    Bairro
                  </label>
                  <input
                    type="text"
                    value={formData.BAIRRO}
                    onChange={(e) => setFormData({...formData, BAIRRO: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    CEP
                  </label>
                  <input
                    type="text"
                    value={formData.CEP}
                    onChange={(e) => setFormData({...formData, CEP: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    Cidade
                  </label>
                  <input
                    type="text"
                    value={formData.CIDADE}
                    onChange={(e) => setFormData({...formData, CIDADE: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600' }}>
                    Estado
                  </label>
                  <input
                    type="text"
                    maxLength={2}
                    value={formData.ESTADO}
                    onChange={(e) => setFormData({...formData, ESTADO: e.target.value.toUpperCase()})}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px'
                    }}
                  />
                </div>

                {/* Status - Apenas ao editar */}
                {medicoSelecionado && (
                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        checked={formData.INATIVO === 'T'}
                        onChange={(e) => setFormData({...formData, INATIVO: e.target.checked ? 'T' : 'F'})}
                        style={{ width: '20px', height: '20px' }}
                      />
                      <span style={{ fontWeight: '600' }}>Médico Inativo</span>
                    </label>
                  </div>
                )}
              </div>

              <div style={{
                marginTop: '20px',
                paddingTop: '20px',
                borderTop: '1px solid #e5e7eb',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px'
              }}>
                <button
                  type="button"
                  onClick={fecharModal}
                  style={{
                    padding: '10px 20px',
                    background: '#6b7280',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontWeight: '600'
                  }}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  style={{
                    padding: '10px 20px',
                    background: '#3b82f6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontWeight: '600'
                  }}
                >
                  {medicoSelecionado ? 'Salvar Alterações' : 'Cadastrar Médico'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Medicos;
